<template>
    <el-dialog
            class="more-box"
            :visible.sync="dialogVisible"
            :before-close="handleClose"
            :close-on-click-modal="false"
            :append-to-body="true"
            title="素材库"
            width="1170px">
        <Material
            v-if="visible"
            :isEdit="isEdit"
            :curEditItem="curEditItem"
            :value.sync="htmlContent"
            :type.sync="newType"
            :search.sync="search"
            :catalog.sync="newCatalog"
            :isCallBack="true"
            :isCocos="isCocos"
            @success="success"
        />
        <p class="search">
            <el-input
                placeholder="输入搜索名称"
                v-model="searchValue"
                size="small"
                @keyup.enter.native.stop="onSearch"
            ></el-input>
        </p>
    </el-dialog>
</template>

<script>
import Material from '../../../Material'

export default {
  name: 'more',
  components: {
    Material
  },
  props: {
    value: String,
    isEdit: {
      type: Boolean,
      default: false
    },
    isCocos: {
      type: Boolean,
      default: false
    },
    curEditItem: Object,
    visible: {
      type: Boolean,
      default: false
    },
    type: String,
    // 当前选中的目录
    catalog: String
  },
  watch: {
    value (vl) { this.newValue = vl },
    newValue (vl) { this.$emit('update:value', vl) },
    visible (vl) { this.dialogVisible = vl },
    dialogVisible (vl) { this.$emit('update:visible', vl) },
    type (vl) { this.newType = vl },
    newType (vl) { this.$emit('update:type', vl) },
    catalog (vl) { this.newCatalog = vl },
    newCatalog (vl) { this.$emit('update:catalog', vl) }
  },
  data () {
    return {
      newValue: this.value,
      newCatalog: this.catalog, // 当前选中的目录-(用于场景选择)
      searchValue: '',
      search: '', // 搜索
      dialogVisible: this.visible,
      htmlContent: '', // 富文本内容
      newType: this.type
    }
  },
  methods: {
    success (item) {
      console.log('选中==>', item)
      this.newValue = item.url
      this.handleClose()
    },
    onSearch () {
      this.search = this.searchValue
      console.log('搜索==>', this.search)
    },
    handleClose () {
      this.dialogVisible = false
      this.searchValue = ''
      this.search = this.searchValue
    },
    change (html) {
      this.htmlContent = html
    },
    close () {
      this.dialogVisible = false
      this.htmlContent = ''
    },
    handleSend () {
      this.$emit('onEditContent', this.htmlContent)
      this.close()
    }
  }
}
</script>

<style scoped>
.more-box >>> .el-dialog__body{
    padding: 0px;
}
.more-box >>> .el-dialog__header{
    border-bottom: 1px solid #f1f1f1;
}
    .search{
        position: absolute;
        right: 50px;
        top: 12px;
    }
    .more-box >>> .el-input.is-active .el-input__inner,
    .more-box >>> .el-input__inner:focus{
        border-color: #DCDFE6 !important;
    }
</style>
